import React from "react";
import { useQuickSightS3 } from "@/hooks/useS3Reports";
import AWSReportsTemplate from "@/components/templates/AWSReportsTemplate";
import QuickSightAwsS3Dashboard from "@/components/organisms/S3Dashboard";

function S3Reports() {
  const { embedUrl, loading, error, refetch } = useQuickSightS3();

  return (
    <AWSReportsTemplate
      title="AWS S3 Dashboard"
      loading={loading}
      error={error}
      onRetry={refetch}
      hideFilters={true}
      hideDownload={true}
    >
      <QuickSightAwsS3Dashboard />
    </AWSReportsTemplate>
  );
}

export default S3Reports;
